import React, { useEffect } from 'react';
import { theme } from '../theme';

interface RueckgaengigToastProps {
  message: React.ReactNode;
  visible: boolean;
  // Optional. When omitted, no Rückgängig button is rendered — toast becomes a
  // plain info-toast (used for "Nothing to {action}" prompts) and auto-dismisses faster.
  onUndo?: () => void;
  onDismiss: () => void;
  durationMs?: number;
}

// Bottom-centered toast. Two modes:
//   - undo mode (onUndo provided): 30 s default, shows Rückgängig button.
//   - info mode (onUndo omitted):  4 s default, no button.
export const RueckgaengigToast: React.FC<RueckgaengigToastProps> = ({
  message, visible, onUndo, onDismiss, durationMs,
}) => {
  const effectiveDuration = durationMs ?? (onUndo ? 30000 : 4000);
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(onDismiss, effectiveDuration);
    return () => clearTimeout(t);
  }, [visible, effectiveDuration, onDismiss]);

  if (!visible) return null;
  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '10px 16px', fontSize: 13,
      fontFamily: theme.font.family,
      backgroundColor: theme.colors.navy, color: theme.colors.white,
      borderRadius: theme.borderRadius.md,
      boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
      animation: 'stx-fadeIn 0.2s ease',
      zIndex: 100,
    }}>
      <span>{message}</span>
      {onUndo && (
        <button onClick={onUndo}
          style={{
            background: 'transparent', border: `1px solid ${theme.colors.white}`,
            color: theme.colors.white, fontSize: 12, fontWeight: 600,
            padding: '4px 10px', borderRadius: theme.borderRadius.sm,
            cursor: 'pointer', fontFamily: theme.font.family,
          }}>
          Rückgängig
        </button>
      )}
    </div>
  );
};
